import React from "react";
import "./projecttooltip.css";

const ProjectTooltip = ({
  continuous,
  index,
  step,
  backProps,
  primaryProps,
  skipProps,
  closeProps,
  tooltipProps,
  size,
  isLastStep,
}) => {
  return (
    <div {...tooltipProps} className="tour-tooltip">

      {/* TOP — step counter + close */}
      <div className="tour-top">
        <div className="tour-step">
          Step {index + 1} / {size}
        </div>
        <button {...closeProps} className="tour-close">
          ✕
        </button>
      </div>

      {/* TITLE */}
      <h2 className="tour-title">{step.title}</h2>

      {/* CONTENT */}
      <p className="tour-content">{step.content}</p>

      {/* FOOTER */}
      <div className="tour-footer">

        {/* Previous — hidden on first step */}
        <div>
          {index > 0 && (
            <button {...backProps} className="tour-back">
              ← Previous
            </button>
          )}
        </div>

        <div className="tour-right">

          {/* Skip — hidden on last step */}
          {!isLastStep && (
            <button {...skipProps} className="tour-skip">
              Skip
            </button>
          )}

          {/* Next or Finish */}
          {isLastStep ? (
            <button {...closeProps} className="tour-next">
              Finish ✓
            </button>
          ) : (
            <button {...primaryProps} className="tour-next">
              Next →
            </button>
          )}

        </div>
      </div>

    </div>
  );
};

export default ProjectTooltip;